import { z } from 'zod';

const cameraChannelParamsZod = z.object({
  channels: z.array(z.string()).default([]),
});

export type CameraChannelParams = z.infer<typeof cameraChannelParamsZod>;

const emptyParamsZod = z.object({}).default({});

export const strategyConfigZod = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('CAMERA_CHANNEL'),
    params: cameraChannelParamsZod.default({ channels: [] }),
  }),
  z.object({ type: z.literal('FIFO'), params: emptyParamsZod }),
  z.object({ type: z.literal('RANDOM'), params: emptyParamsZod }),
  z.object({ type: z.literal('FRAME_COUNT'), params: emptyParamsZod }),
  z.object({ type: z.literal('ANNOTATION_COUNT'), params: emptyParamsZod }),
]);

export const pickupStrategyZod = z.object({
  role: z.enum(['label', 'qa']),
  config: strategyConfigZod,
});

export type PickupStrategy = z.infer<typeof pickupStrategyZod>;

export const pickupStrategyRowZod = z
  .object({
    sample_group_token: z.string(),
    created_at: z.coerce.date(),
    updated_at: z.coerce.date(),
  })
  .merge(pickupStrategyZod);

export type PickupStrategyRow = z.infer<typeof pickupStrategyRowZod>;

export const DEFAULT_QA_PICKUP_STRATEGY: PickupStrategy = {
  role: 'qa',
  config: { type: 'RANDOM', params: {} },
};

export const DEFAULT_LABEL_PICKUP_STRATEGY: PickupStrategy = {
  role: 'label',
  config: { type: 'FIFO', params: {} },
};

export const pickupStrategiesMapZod = z.object({
  label: pickupStrategyRowZod.optional(),
  qa: pickupStrategyRowZod.optional(),
});

export type PickupStrategiesMap = z.infer<typeof pickupStrategiesMapZod>;
